<div
  class="d-dark-mode-none position-absolute top-0 start-0 w-100 h-100 bg-repeat-0 bg-position-center bg-size-cover"
  style="background-image: url(assets/img/404/light/bg.jpg)"
></div>

<div
  class="d-none d-dark-mode-block position-absolute top-0 start-0 w-100 h-100 bg-repeat-0 bg-position-center bg-size-cover"
  style="background-image: url(assets/img/404/dark/bg.jpg)"
></div>

<component-topbar headerClassName="fixed-top" />

<section
  class="container d-flex flex-column h-100 align-items-center position-relative zindex-5 pt-5"
>
  <div class="text-center pt-5 pb-3 mt-auto">
    <div
      class="parallax mx-auto d-dark-mode-none"
      style="max-width: 574px"
      appParallax
    >
      <div class="parallax-layer" data-depth="-0.15">
        <img src="assets/img/404/light/layer01.png" alt="Layer" />
      </div>
      <div class="parallax-layer" data-depth="0.12">
        <img src="assets/img/404/light/layer02.png" alt="Layer" />
      </div>
      <div class="parallax-layer zindex-5" data-depth="-0.12">
        <img src="assets/img/404/light/layer03.png" alt="Layer" />
      </div>
    </div>

    <div
      class="parallax mx-auto d-none d-dark-mode-block"
      style="max-width: 574px"
      appParallax
    >
      <div class="parallax-layer" data-depth="-0.15">
        <img src="assets/img/404/dark/layer01.png" alt="Layer" />
      </div>
      <div class="parallax-layer" data-depth="0.12">
        <img src="assets/img/404/dark/layer02.png" alt="Layer" />
      </div>
      <div class="parallax-layer zindex-5" data-depth="-0.12">
        <img src="assets/img/404/dark/layer03.png" alt="Layer" />
      </div>
    </div>

    <h1 class="visually-hidden">404</h1>
    <h2 class="display-5">Ooops!</h2>
    <p class="fs-xl pb-3 pb-md-0 mb-md-5">
      The page you are looking for is not available.
    </p>
    <a
      routerLink="/"
      class="btn btn-lg btn-primary shadow-primary w-sm-auto w-100"
    >
      <i class="bx bx-home-alt me-2 ms-n1 lead"></i>
      Go to homepage
    </a>
  </div>

  <div class="text-center py-lg-5 py-4 mt-auto">
    <p class="nav d-block fs-sm pt-3 pt-lg-0 mb-0">
      <span class="opacity-75">&copy; All rights reserved. Made by </span>
      <a
        class="nav-link d-inline-block p-0"
        href="{{ creditsBy.website }}"
        target="_blank"
        rel="noopener"
      >
        {{ creditsBy.name }}</a
      >
    </p>
  </div>
</section>
